export enum SyteLayout {
  ResultsModal = 'resultsModal',
}
